import { Controller } from "@hotwired/stimulus";
import Dashboard from "@uppy/dashboard";
import { uploadedFileData, uppyInstance } from "../uppy";
// https://github.com/erikdahlstrand/shrine-rails-example/blob/master/app/javascript/src/uppy.js

export default class extends Controller {
  static targets = ["dashboard", "hiddenInput"];
  static values = { modelName: String };

  connect() {
    this.initializeUppy();
    this.restoreExistingUploads();
  }

  initializeUppy() {
    this.uppy = uppyInstance().use(Dashboard, {
      target: this.dashboardTarget,
      inline: true,
      height: 300,
      replaceTargetContent: true,
    });

    this.uppy.on("upload-success", (file, response) => {
      const hiddenField = document.createElement("input");

      hiddenField.type = "hidden";
      hiddenField.name = `${this.modelNameValue}[photos_attributes][${Date.now()}][image]`;

      hiddenField.value = uploadedFileData(file);

      this.element.appendChild(hiddenField);
    });
  }

  restoreExistingUploads() {
    this.hiddenInputTargets.forEach((input) => {
      const fileData = JSON.parse(input.value);

      this.uppy.addFile({
        name: fileData.metadata.filename,
        type: fileData.metadata.mime_type,
        data: {
          url: input.dataset.url,
        },
        source: "restored",
        isRemote: true,
      });
    });
  }

  disconnect() {
    // if (this.uppy) {
    //   this.uppy.close()
    // }
  }
}
